import React from 'react';
import styled from '@emotion/styled';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { USER_PROFILE } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';

export const UserProfileSearch = (props: any) => {
  const { t } = useTranslation(USER_PROFILE);
  const { setSearchEmail, findItemByEmail, form, close, setValueSearch } = props;
  return (
    <StyledRowFilter>
      <Col span={6} className="search">
        <Form form={form} layout="vertical" className="search-form">
          <Form.Item
            name="searchEmail"
            rules={[
              { required: true, message: t('validate.email') },
              { type: 'email', message: t('validate.emailFormat') },
            ]}
          >
            <StyledSearchInput
              placeholder={t('filter.searchPlaceholder')}
              onChange={e => {
                setSearchEmail(e.target.value);
              }}
              suffix={close ? <CloseOutlined onClick={setValueSearch} /> : <SearchOutlined onClick={findItemByEmail} />}
            />
          </Form.Item>
        </Form>
      </Col>
    </StyledRowFilter>
  );
};

const StyledRowFilter = styled(Row)`
  padding: 0.5rem 0 0.75rem;
  & .full-width {
    .ant-select {
      width: 280px;
      min-width: 280px;
      max-width: 400px;
    }
  }

  & .ant-col {
    display: flex;
    & .text-filter {
      display: table;
      height: 36px;
      margin-right: 0.5rem;
      & span {
        font-weight: bold;
        font-size: 14px;
        display: table-cell;
        vertical-align: middle;
      }
    }
    & .ant-select-selector {
      line-height: 1.89;
    }
  }

  & .div-filter-passScheduledArrivalDate,
  & .div-filter-abnormalOrder {
    padding: 0.22rem;
  }
  & .search {
    margin-left: auto;
  }
  & .search-form {
    flex: 1;
  }
`;

const StyledSearchInput = styled(Input)`
  ${appStyles.searchInput}
`;
